module.exports = __webpack_public_path__ + "img/primary_10x3.2cc46dac.svg";